import src from "IMAGE";
export default { src, width: 1235, height: 650, blurWidth: 0, blurHeight: 0};
